export default __webpack_public_path__ + "static/media/pause-menu.0c7e8c3c.png";